import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CookieContextType {
  openSettings: () => void;
}

const CookieContext = createContext<CookieContextType | undefined>(undefined);

export const useCookieContext = () => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error('useCookieContext must be used within a CookieProvider');
  }
  return context;
};

interface CookieProviderProps {
  children: ReactNode;
  onOpenSettings: () => void;
}

export const CookieProvider: React.FC<CookieProviderProps> = ({ children, onOpenSettings }) => {
  return (
    <CookieContext.Provider value={{ openSettings: onOpenSettings }}>
      {children}
    </CookieContext.Provider>
  );
};